const getDrawer = state => state.drawer

export default {
  getDrawer,
}
